/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_objetivos': {
    width: 16,
    height: 16,
    viewBox: '0 0 14.664 16',
    data: '<g _fill="#959ba6"><path pid="0" d="M1.592.8A.8.8 0 000 .8v14.4a.8.8 0 001.592 0V8.9z" data-name="Path 4369"/><path pid="1" d="M12.164 4.356a.49.49 0 010-.606 16.227 16.227 0 012.257-2.224c.644-.518-.2-.9-.384-.975-3.829-1.614-7.659 1.764-11.488.738v7.972c3.837 1.029 7.674-2.363 11.51-.728.187.079.358.06.441-.064a.556.556 0 00-.053-.544 31.957 31.957 0 00-2.283-3.569z" data-name="Path 4370"/></g>'
  }
})
